import { URLs } from '../../../lib/constants';
import type { SoldOutCardPresenterProps, SoldOutCardProps } from './SoldOutCard.types';

export const usePresenter = (props: SoldOutCardProps): SoldOutCardPresenterProps => {
  return {
    ...props,
    linkHref: URLs.ExclusiveEventsPage,
  };
};
